import React, { useState, useEffect } from "react";
import { Box, Text, Image } from "@chakra-ui/react";
import { Storage } from "aws-amplify";

export const UpsellBox = ({ upsell, defaultCurrency, pricePreview, onClick }) => {
  const [imageUrl, setImageUrl] = useState(null);

  useEffect(() => {
    const loadImage = async () => {
      if (upsell.images && upsell.images.length > 0) {
        try {
          const url = await Storage.get(upsell.images[0]); // Get first image
          setImageUrl(url);
        } catch (error) {
          console.error("Error loading image:", error);
          setImageUrl(null);
        }
      }
    };

    loadImage();
  }, [upsell.images]);
  
  return (
    <Box
      bg="#2D3748"
      borderRadius="10px"
      w="200px"
      h="190px"
      onClick={onClick}
      display="flex"
      flexDirection="column"
      justifyContent={imageUrl ? "flex-end" : "center"}
      py={imageUrl ? 0 : 4}
    >
      {imageUrl ? (
        <>
          <Box flex="1" mb={3} overflow="hidden">
            <Image 
              src={imageUrl}
              alt={upsell.name}
              objectFit="cover"
              w="100%"
              h="100%"
              borderTopRadius="9px"
            />
          </Box>
          <Text 
            fontSize="14px" 
            fontWeight={800} 
            mb={1} 
            px={2}
            noOfLines={1}
            overflow="hidden"
            textOverflow="ellipsis"
            whiteSpace="nowrap"
          >
            {upsell.name.length > 20 
              ? `${upsell.name.substring(0, 20)}...` 
              : upsell.name}
          </Text>
          {upsell.price > 0 ? (
            <Text fontSize="12px" color="#D0D0D0" fontWeight={800} mb={2} px={2}>
              {pricePreview
                ? `${(pricePreview.total / 100).toLocaleString("en-CA", {
                    style: "currency",
                    currency: pricePreview.currency.toUpperCase(),
                  })} ${pricePreview.currency.toUpperCase()}`
                : `${upsell.price.toLocaleString("en-CA", {
                    style: "currency",
                    currency: defaultCurrency,
                  })} ${defaultCurrency}`}
            </Text>
          ) : (
            <Box h="18px" mb={2} />
          )}
        </>
      ) : (
        <>
          <Text 
            fontSize="14px" 
            fontWeight={800} 
            mb={2} 
            px={2}
            noOfLines={1}
            overflow="hidden"
            textOverflow="ellipsis"
            whiteSpace="nowrap"
          >
            {upsell.name.length > 20 
              ? `${upsell.name.substring(0, 20)}...` 
              : upsell.name}
          </Text>
          {upsell.description && (
            <Text 
              fontSize="12px" 
              color="#A0AEC0" 
              mb={2} 
              px={2}
              noOfLines={3}
              overflow="hidden"
              textOverflow="ellipsis"
            >
              {upsell.description}
            </Text>
          )}
          {upsell.price > 0 && (
            <Text fontSize="12px" color="#D0D0D0" fontWeight={800} px={2}>
              {pricePreview
                ? `${(pricePreview.total / 100).toLocaleString("en-CA", {
                    style: "currency",
                    currency: pricePreview.currency.toUpperCase(),
                  })} ${pricePreview.currency.toUpperCase()}`
                : `${upsell.price.toLocaleString("en-CA", {
                    style: "currency",
                    currency: defaultCurrency,
                  })} ${defaultCurrency}`}
            </Text>
          )}
        </>
      )}
    </Box>
  );
}; 